import React, { ReactNode, useContext, useEffect, useState } from 'react';
import { ApolloProvider } from '@apollo/client';
import { ToastContainer } from 'react-toastify';
import { Apolloclient } from './src/providers/apollo/client';
import { AppCtx } from './src/providers/auth.providers';

interface WrapWithApolloProps {
	children: ReactNode;
}

const WrapWithApollo: React.FC<WrapWithApolloProps> = ({ children }) => {
	const { token } = useContext(AppCtx);
	const [apolloClient, setApolloClient] = useState(Apolloclient());

	useEffect(() => {
		if (token) {
			setApolloClient(Apolloclient(token));
		}
	}, [token]);

	return (
		<ApolloProvider client={apolloClient}>
			<ToastContainer />
			{children}
		</ApolloProvider>
	);
};

export default WrapWithApollo;
